import { render, staticRenderFns } from "./CargaMasivaPage.vue?vue&type=template&id=bfab8be2"
import script from "./CargaMasivaPage.js?vue&type=script&lang=js&external"
export * from "./CargaMasivaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports